<template>
  <div class="d-flex flex-column align-items-center">
    <h2 class="text-h4 text-center mb-4">{{ title }}</h2>
    <p class="text-subtitle-1 text-center mb-8">{{ description }}</p>
    <gg-btn class="mb-2" @click="$emit('start')">Get Started</gg-btn>
    <gg-btn text @click="$emit('skip')">Skip for now</gg-btn>
  </div>
</template>

<script>
export default {
  name: 'WelcomingStep',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>
